<template>
  <Modal
    v-model="_value"
    width="400"
    title="SIM卡分配分组"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form v-if="simInfoList.length > 0" ref="loginForm" :model="simInfoList">
      <div v-for="item in simInfoList">
        <FormItem prop="simNum" label="SIM卡号">
          <label style="display: inline-block;">{{item.simNum}}</label>
        </FormItem>
      </div>
      <FormItem prop="name" label="分组信息">
        <Select class="field" v-model="simInfo.userGroupId">
          <Option v-for="item in userGroups" :value="item.id" :key="item.name">{{item.name}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else ref="loginForm" :model="simInfo">
      <FormItem prop="name" label="分组信息">
        <Select class="field" v-model="simInfo.userGroupId">
          <Option v-for="item in userGroups" :value="item.id" :key="item.name">{{item.name}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'siminfochangeusergroupmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      userGroups: [
        { name: '中山', id: 1 },
        { name: '江门', id: 2 }
      ],
      simInfo: {
        id: null,
        userGroupId: null
      },

      simInfoList: [],
      simInfoIds: []
    }
  },
  methods: {
    ...mapActions([
    ]),
    onOk () {
      if (this.simInfoList != null && this.simInfoList.length > 0) {
        store.dispatch('SimInfoServ_BatchChangeGroup', {
          params:
            {
              ids: this.simInfoIds,
              userGroupId: this.simInfo.userGroupId
            },
          urlparams: null
        }).then(() => {
          this.$Message.success('分配SIM卡分组成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '指派安装员',
          content: '<p>确认分配SIM卡分组</p>',
          onOk: () => {
            store.dispatch('SimInfoServ_ChangeGroup', {
              params: {
                id: this._initValue,
                userGroupId: this.simInfo.userGroupId
              }
            }).then(() => {
              this.$Message.success('分配SIM卡分组成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        console.log(this._listValue)
        this.simInfoList = this._listValue
        this.simInfoIds = []
        if (this.simInfoList != null && this.simInfoList.length > 0) {
          this.simInfoList.forEach(item => {
            this.simInfoIds.push(item.id)
          })
        } else {
          this.simInfoIds = []

          this.simInfo.id = null
          this.simInfo.userGroupId = null

          let simInfoId = this._initValue
          if (simInfoId) {
            store.dispatch('SimInfoServ_GetDetail', {
              params: { id: simInfoId }
            }).then(() => {
              this.simInfo = store.getters.get_SimInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
